<!--
  Wrap icon + ring in one element so mat-fab does not project mat-icon into the
  leading slot (side-by-side) and break the circular scroll indicator overlay.
-->
<button 
  class="back-to-top-button"
  [class.visible]="isVisible"
  (click)="scrollToTop()"
  mat-fab
  matTooltip="Back to top"
  matTooltipPosition="left"
  aria-label="Back to top">
  <span class="back-to-top-inner">
    <svg class="progress-ring" viewBox="0 0 56 56" aria-hidden="true">
      <circle
        class="progress-ring-background"
        stroke="rgba(255, 255, 255, 0.2)"
        stroke-width="3"
        fill="transparent"
        r="18"
        cx="28"
        cy="28"/>
      <circle
        class="progress-ring-circle"
        [attr.stroke-dashoffset]="strokeDashoffset"
        stroke="var(--membertrace-accent)"
        stroke-width="3"
        fill="transparent"
        r="18"
        cx="28"
        cy="28"/>
    </svg>
    <mat-icon class="arrow-icon" aria-hidden="true">arrow_upward</mat-icon>
  </span>
</button>

